import { SafeMarkdown } from "@neru/base/components";
import { Row } from "@neru/ui";

interface OverviewProps {
  description: string;
}

export const Overview = ({ description }: OverviewProps) => (
  <Row>
    <SafeMarkdown className="markup neru-markup">{description}</SafeMarkdown>
  </Row>
);
